<template>
  <div class="fs-16 fc-white">
    <div class="bg-f4f9f9 p10">
    <div class="relative banner">
      <div class="line-height110 relative z-index1">
           <div>提现银行</div>
           <div>{{ msg }}</div>
      </div>
      <img class="absolute banner_img" :src="dealBanner" alt="银行卡">
    </div>
    </div>
  </div>
</template>

<script>
import dealBanner from './../../assets/deal_banner.png'; // 选中icon
export default {
  components: {
  },
  props:{
    msg:{}, // 银行卡消息
  },

  data() {
    return {
      dealBanner: dealBanner,
    };
  },
  methods: {
    

  },
};
</script>

<style lang='less'>
.banner{
  height: 110px;
  padding:15px;
  background-color: #008c8c;
}
.line-height110{
  line-height: 55px;
}
.banner_img{
  display: inline-block;
  height: 150px;
  right: 0;
  top: 0;
  z-index: 0;
}
</style>